import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";

function getPdfUrlFromSearch(search) {
  const params = new URLSearchParams(search);
  return params.get("pdf") ? decodeURIComponent(params.get("pdf")) : null;
}

const PDFViewer = () => {
  const location = useLocation();
  const url = useMemo(() => getPdfUrlFromSearch(location.search), [location]);

  if (!url) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.1rem",
          color: "#888",
          background: "#fafbfc"
        }}
      >
        لا يوجد ملف PDF للعرض
      </div>
    );
  }

  return (
    <iframe
      src={url}
      title="PDF Viewer"
      width="100%"
      height="100%"
      style={{
        border: "none",
        minHeight: "100vh",
        minWidth: "100vw",
        display: "block",
        background: "#fafbfc"
      }}
      allowFullScreen
    />
  );
};

export default PDFViewer;
